import { render, staticRenderFns } from "./rivacypolicy.vue?vue&type=template&id=5a5df7da&scoped=true&"
import script from "./rivacypolicy.vue?vue&type=script&lang=js&"
export * from "./rivacypolicy.vue?vue&type=script&lang=js&"
import style0 from "./rivacypolicy.vue?vue&type=style&index=0&id=5a5df7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5df7da",
  null
  
)

component.options.__file = "rivacypolicy.vue"
export default component.exports